var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-boxes-container",class:_vm.extraClass},_vm._l((_vm.data),function(item){return _c('card-box',{key:item.id,attrs:{"data":item,"disable-actions":_vm.disableActions}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }